import { TableColumn } from '@backstage/core-components';
import { columnFactories } from './columns';
import { CatalogTableColumnsFunc, CatalogTableRow } from './types';

export const defaultCatalogTableColumnsFunc: CatalogTableColumnsFunc = ({
  filters,
  entities,
}) => {
  const showTypeColumn = filters.type === undefined;

  return [
    columnFactories.createTitleColumn({ hidden: true }),
    columnFactories.createNameColumn({ defaultKind: filters.kind?.value }),
    ...createEntitySpecificColumns(),
  ];

  function createEntitySpecificColumns(): TableColumn<CatalogTableRow>[] {
    const descriptionTagColumns = [
      columnFactories.createMetadataDescriptionColumn(),
      columnFactories.createTagsColumn(),
    ];
    const baseColumns = [
      columnFactories.createSystemColumn(),
      columnFactories.createOwnerColumn(),
      columnFactories.createSpecTypeColumn({ hidden: !showTypeColumn }),
      columnFactories.createSpecLifecycleColumn(),
    ];
    switch (filters.kind?.value) {
      case 'user':
        return [...descriptionTagColumns];
      case 'domain':
      case 'system':
        return [columnFactories.createOwnerColumn(), ...descriptionTagColumns];
      case 'group':
      case 'template':
        return [
          columnFactories.createSpecTypeColumn({ hidden: !showTypeColumn }),
          ...descriptionTagColumns,
        ];
      case 'location':
        return [
          columnFactories.createSpecTypeColumn({ hidden: !showTypeColumn }),
          columnFactories.createSpecTargetsColumn(),
        ];
      default:
        return entities.every(entity => entity.metadata.namespace === 'default')
          ? [...baseColumns, ...descriptionTagColumns]
          : [
              ...baseColumns,
              columnFactories.createNamespaceColumn(),
              ...descriptionTagColumns,
            ];
    }
  }
};